export const serializeObject = (object: Record<string, any>) => {
  return Object.entries(object)
    .map(([key, value]) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    })
    .join('&')
}
